import styled from 'styled-components';

export const PriceInfo = styled.div`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  color: #9f9f9f;
  padding-bottom: 25px;
  border-bottom: 1px solid #9f9f9f;
`;
